<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="(parameterNames.release_group_id_name = null),(parameter.release_group_id = null)"
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="(parameterNames.pitcher_id_name = null),(parameter.pitcher_id = null)"
        />
      </div>
      <div class="item">
        <span class="item_title">运营组</span>
        <el-autocomplete
          v-model="parameterNames.operation_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '运营组'"
          @clear="(parameterNames.operation_group_id_name = null),(parameter.operation_group_id = null)"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">运营者</span>
        <el-autocomplete
          v-model="parameterNames.operation_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '运营者'"
          @clear="(parameterNames.operation_id_name = null),(parameter.operation_id = null)"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">平台</span>
        <el-autocomplete
          v-model="parameterNames.platform_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请选择平台"
          :clearable="true"
          @focus="current = '平台'"
          @clear="platform_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">书名</span>
        <el-autocomplete
          v-model="parameterNames.book_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书名'"
          @clear="(parameterNames.book_name = null)"
          @select="handleSelect"
        />
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-circle-plus" @click="establish">创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
        />
        <el-table-column
          prop="platform_name"
          label="平台"
        />
        <el-table-column
          prop="release_group_name"
          label="投放组"
        />
        <el-table-column
          prop="pitcher_name"
          label="投手"
        />
        <el-table-column
          prop="operation_group_name"
          label="运营组"
        />
        <el-table-column
          prop="operation_name"
          label="运营者"
        />
        <el-table-column
          prop="book_name"
          label="书名"
          width="120"
        />
        <el-table-column
          prop="begin_time"
          label="开始时间"
        />
        <el-table-column
          prop="end_time"
          label="结束时间"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <el-table-column
          label="操作"
          min-width="150"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
            <el-button type="primary" size="mini" @click="myDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="drawerItem.id ? '修改关系' : '创建关系'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="50%"
      style="min-width:700px"
      @closed="drawerItem = {}"
    >
      <Details v-if="dialogVisible" ref="details" :drawer-item="drawerItem" @determine="determine" />
    </el-dialog>

  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { getBindingRelationList, getReleaseGroupList, getListOfPitchersInTheLaunchGroup, getOperationGroupList, getOperatorList, getTitleList, addReleaseRelationship, modifyReleaseRelationship, deleteReleaseRelationship, modifyStandard } from '@/api/oceanNovelReport.js'
import { mapGetters } from 'vuex'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Details from './components/details.vue'
import { getSelectList } from '@/api/report/SelectData.js'

export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        book_id: null,
        platform_id: null
      },
      parameterNames: {
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        book_name: null, // 书名
        platform_name: null
      },
      current: null,
      dialogVisible: false,
      drawerItem: {},
      standardItem: null, // RIO消耗修改
      standardText: null
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters(['getBindingRelationship'])
  },
  methods: {
    // 获取数据列表
    async getDataList(obj = {}) {
      console.log(obj, 123123)
      this.loading = true
      const data = await getBindingRelationList(Object.keys(obj).length ? obj : this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 确定
    async determine(obj) {
      const bool = !!this.drawerItem.id

      if (bool) {
        await modifyReleaseRelationship(this.drawerItem.id, obj)
      } else {
        await addReleaseRelationship(obj)
      }

      this.$message({
        message: bool ? '修改关系成功' : '创建关系成功',
        type: 'success'
      })

      this.drawerItem = {}
      this.dialogVisible = false
      this.reset()
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        '投放组': 'release_group_name',
        '投手': 'user_name',
        '运营组': 'operation_group_name',
        '运营者': 'user_name',
        '书名': 'book_name',
        '平台': 'platform_name'
      }

      switch (this.current) {
        case '投放组': currentFunc = getReleaseGroupList
          break
        case '投手': currentFunc = getListOfPitchersInTheLaunchGroup
          break
        case '运营组': currentFunc = getOperationGroupList
          break
        case '运营者': currentFunc = getOperatorList
          break
        case '书名': currentFunc = getTitleList
          break
        case '平台':
          currentFunc = getSelectList
          break
      }
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.parameter.release_group_id || this.current === '运营者' && !this.parameter.operation_group_id) {
        const obj1 = {
          '投手': '请先选投放组，才能选投手',
          '运营者': '请先选运营组，才能选运营者'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : this.current === '运营者' ? this.parameter.operation_group_id.address : null,
        book_id: this.parameter.book_id ? this.parameter.book_id.address : null
      })
      if (this.current === '平台') {
        cb(
          data.data.platform.map(item => {
            return {
              value: item.name,
              address: item.id
            }
          })
        )
        return
      }

      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      }

      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      }
      cb(data.data.list.map((item) => {
        return {
          value: item[obj[this.current]],
          address: this.current === '小程序' ? item.app_id : item.id
        }
      }))
    },

    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '投放组' : this.parameter.release_group_id = item
          break
        case '投手' : this.parameter.pitcher_id = item
          break
        case '运营组' : this.parameter.operation_group_id = item
          break
        case '运营者' : this.parameter.operation_id = item
          break
        case '书名' : this.parameter.book_id = item
          break
        case '平台':
          this.parameter.platform_id = item
          break
      }
    },

    // 搜索
    search(value) {
      console.log(this.parameter)
      value || (this.parameter.page = 1)
      const obj = {
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        book_id: 'book_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      this.getDataList(obj1)
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        app_id: null,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        book_id: null
      }
      this.parameterNames = {
        app_id_name: null, // 小程序
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        book_name: null // 书名
      }
      this.current = null
      this.getDataList()
    },

    // 删除
    async myDelete(row) {
      await deleteReleaseRelationship(row.id)
      this.getDataList()
      this.$message({
        message: '删除成功',
        type: 'success'
      })
    },

    // 创建按钮的点击事件的处理函数
    establish() {
      this.drawerItem = this.getBindingRelationship || {}
      this.dialogVisible = true
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
</style>

<style>
.publicItems .el-dialog{
  margin-top: 6vh !important;
  min-width: 685px !important;
}
</style>
